import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Directives Theme
import { AccordionLinkDirective } from './accordion/accordionlink.directive';
import { AccordionAnchorDirective } from './accordion/accordionanchor.directive';
import { AccordionDirective } from './accordion/accordion.directive';
import { ToggleFullScreenDirective } from './fullscreen/toggle-fullscreen.directive';
import { CardToggleDirective } from './card/card-toggle.directive';

// Modulos
import { RouterModule } from '@angular/router';

// Directives Angular
import { ClickOutsideModule } from 'ng-click-outside';

//
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { ModalBasicComponent } from './modal-basic/modal-basic.component';
import { ModalAnimationComponent } from './modal-animation/modal-animation.component';

import { DeleteRegistroComponent } from './delete-registro/delete-registro.component';

// Components Globales
import { SpinnerComponent } from './spinner/spinner.component';
import { TitleComponent } from './title/title.component';
import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { CardComponent } from './card/card.component';
import { GrdFilterPipe } from './pipes/filter.pipe';
import { DirectiveModule } from '../directives/directive.module';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [
    AccordionLinkDirective,
    AccordionDirective,
    AccordionAnchorDirective,
    ToggleFullScreenDirective,
    TitleComponent,
    SpinnerComponent,
    HeaderComponent,
    MenuComponent,
    BreadcrumbsComponent,
    CardComponent,
    ModalBasicComponent,
    ModalAnimationComponent,
    DeleteRegistroComponent,
    CardToggleDirective,
    GrdFilterPipe
  ],
  imports: [
    FormsModule, ReactiveFormsModule,
    CommonModule,
    PerfectScrollbarModule,
    ClickOutsideModule,
    RouterModule,
    DirectiveModule,
    PipesModule,
    NgbModule.forRoot()
  ],
  exports: [
    NgbModule,
    PerfectScrollbarModule,
    ClickOutsideModule,
    AccordionLinkDirective,
    AccordionDirective,
    AccordionAnchorDirective,
    ToggleFullScreenDirective,
    TitleComponent,
    SpinnerComponent,
    HeaderComponent,
    MenuComponent,
    BreadcrumbsComponent,
    CardComponent,
    ModalBasicComponent,
    ModalAnimationComponent,
    DeleteRegistroComponent,
    CardToggleDirective,
    GrdFilterPipe,

  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  entryComponents: [DeleteRegistroComponent]
})
export class SharedModule { }
